// removed by extract-text-webpack-plugin
module.exports = {"tabArea":"_1MpfoWYEglx0-e1QQFRtnN","linkArea":"_2AVbq9oimzWBTDw5XgP_07","manualContact":"_1dsboC0tH0iaDvGLnaxG9F","logoIcon":"_2LF-8YgToFJKrJuc51UwQV","scrollArea":"_1FYflShIQxlVgY5X2t7erj"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/ManualContact/manual-contact.scss
// module id = 13272
// module chunks = 0